<template>
  <div id="wrapper" class="page">
    <qtake-side-bar index="1" />
    <div id="content-wrapper">
      <div id="qtake_schedule_fluid" class="container-fluid">
        <!-- <div class="mydiv">
          <b-form inline>
            <i class="fas fa-filter" id="popover-target-1"></i>
            <div style="flex-grow: 1" class="text-center">QTAKE BOOKING</div>
            <button
              class="btn btn-info"
              @click.prevent="openModal"
              v-if="qtake_create"
            >
              <i class="fas fa-plus"></i> Book
            </button>
          </b-form>
        </div> -->
        <div class="mydiv">
          <b-row class="">
            <b-col
              style="width:80px; min-width:80px;  max-width:80px; padding-right: 0px;padding-left: 0px;"
            >
              <button
                class="btn-sm btn-outline-secondary border-0 float-left"
                style="padding-top:1px; padding-bottom:1px; background-color: #fde3c1;"
                @click.prevent="$refs.vuecal.previous()"
              >
                <i
                  style="font-size: 31px !important;"
                  class="fas fa-angle-left"
                ></i>
              </button>
              <button
                class="btn-sm btn-outline-secondary border-0 float-left"
                style="background-color: #fde3c1; margin-left:3px;"
                id="popover-target-1"
              >
                <i
                  class="fas fa-filter"
                  style="font-size: 22px !important; padding: 2px 0px 2px 0px;"
                ></i>
              </button>
            </b-col>
            <b-col
              style="width: 80px; min-width: 80px; max-width: 80px; padding-right: 0px;padding-left: 0px;"
            ></b-col>
            <b-col
              style="flex-grow: 1; font-size: 20px; font-weight: bold;"
              class="text-center"
            >
              {{ $convert_date_string_master(this.startDate) }}
            </b-col>
            <b-col
              style="width: 80px; min-width: 80px; max-width: 80px; padding-right: 0px;padding-left: 0px;"
            >
              <div
                style="width: 80px; min-width: 80px; max-width: 80px; padding-right: 0px;padding-left: 0px; background-color: #2c2c2c; border-radius: 0.2rem;"
              >
                <button
                  class="btn-sm border-0 button--pandora"
                  style="width: 80px; padding: 4px 2px 4px 4px; "
                  @click.prevent="openModal"
                  v-if="qtake_create"
                >
                  <i
                    class="fas fa-plus-circle"
                    style="float: left; font-size: 23px;"
                  ></i>
                  Book
                </button>
              </div>
            </b-col>
            <b-col
              style="width:80px; min-width:80px;  max-width:80px; padding-right: 0px;padding-left: 0px;"
            >
              <button
                class="btn-sm btn-outline-secondary border-0 float-right"
                style="padding-top:1px; padding-bottom:1px; background-color: #fde3c1;"
                @click.prevent="$refs.vuecal.next()"
              >
                <i
                  style="font-size: 31px !important;"
                  class="fas fa-angle-right"
                ></i>
              </button>
              <button
                class="btn-sm btn-outline-secondary border-0 float-right"
                style="padding-top:4px; padding-bottom:3px; background-color: #fde3c1; margin-right:3px;"
                @click.prevent="$refs.vuecal.switchView('month', new Date())"
              >
                <i
                  style="font-size: 25px !important;"
                  class="fas fa-map-marker-alt "
                ></i>
              </button>
            </b-col>
          </b-row>
        </div>
        <b-popover
          target="popover-target-1"
          triggers="click blur"
          placement="top"
        >
          <template v-slot:title>
            Choose filter
          </template>
          <b-form-group>
            <b-form-checkbox-group
              v-model="qtake_departments_selected"
              :options="qtake_departments"
              value-field="id"
              text-field="name"
              @input="change_qtake_department_selected"
              stacked
            ></b-form-checkbox-group>
          </b-form-group>
        </b-popover>

        <vue-cal
          ref="vuecal"
          hide-view-selector
          hide-title-bar
          :disable-views="['years', 'year', 'week', 'day']"
          today-button
          locale="en"
          :time-from="8 * 60"
          :time-to="20 * 60"
          :events="qtakes"
          :time-step="30"
          :on-event-click="openUpdateModal"
          @hidden="closeModal"
          @ready="viewChange"
          @view-change="viewChange"
          :active-view.sync="activeView"
          events-on-month-view="short"
        >
          <template v-slot:split-label="{ split }">
            <i class="far fa-building"></i>
            <strong>{{ split.label }}</strong>
          </template>
          <!-- <template v-slot:today-button>
            <i class="fas fa-map-marker-alt"></i>
          </template> -->
          <template v-slot:cell-content="{ cell }">
            <span
              class="vuecal__cell-date m-1"
              :style="{
                color:
                  cell.class == 'vuecal__cell--day6' ||
                  cell.class == 'vuecal__cell--day7'
                    ? cell.outOfScope != true
                      ? '#ffb284'
                      : '#ffb38280'
                    : '',
              }"
              ><div>
                {{ cell.content }}
              </div>
            </span>
          </template>
          <template v-slot:weekday-heading="{ heading }">
            <div
              style="font-weight:bold; width: 100%; border-radius:3px; "
              :style="change_weekdays_headings_color(heading.label)"
            >
              {{ heading.label.substring(0, 3) }}
            </div>
          </template>
          <template v-slot:no-event>{{&nbsp;}}</template>
          <template v-slot:event="{ event }">
            <div
              style="height: 60px; color: #000; border-radius: 3px; margin: 0px 5px 5px 5px;"
              :style="[
                event.status == 0
                  ? {
                      'border-style': 'solid',
                      'border-width': '5px',
                      'border-color': event.color,
                    }
                  : {
                      'border-style': 'solid',
                      'border-width': '5px',
                      'background-color': event.color,
                      'border-color': event.color,
                    },
              ]"
            >
              <div
                v-if="event.status == 0"
                class="vuecal__event-title"
                v-html="findDepartment(event.qtakedepartmentid)"
                style="color:black;font-weight: normal; font-size:15px;"
              />
              <div
                v-else
                class="vuecal__event-title"
                v-html="findDepartment(event.qtakedepartmentid)"
                style="color:white;font-weight: normal; font-size:15px;"
              ></div>
              <div
                v-if="event.status == 0"
                class="vuecal__event-time"
                v-html="event.project"
                style="color:black;font-weight: normal; font-size:17px; font-weight: bold;"
              />
              <div
                v-else
                class="vuecal__event-time"
                v-html="event.project"
                style="color:white;font-weight: normal; font-size:17px; font-weight: bold;"
              ></div>
            </div>
          </template>
        </vue-cal>
      </div>
    </div>

    <!-- QTAKE BOOKING MODAL -->
    <b-modal
      id="modal_add_qtake_booking"
      v-model="modalShow"
      size="lg"
      centered
      scrollable
      @hidden="closeModal"
      :no-close-on-backdrop="true"
      :no-close-on-esc="true"
      header-bg-variant="info"
      header-text-variant="light"
      hide-footer
    >
      <template v-slot:modal-title>
        <div v-if="is_creating_qtake">BOOKING</div>
        <div v-else>EDIT A BOOKING</div>
      </template>
      <b-form autocomplete="off" @submit.prevent="submitQtake">
        <b-row>
          <b-col>
            <badge
              v-if="is_approved"
              variant="primary"
              class="mb-2"
              style="font-size: 20px"
              ><i class="fas fa-check-square mr-2"></i>CONFIRMED</badge
            >
            <b-button
              v-if="!is_creating_qtake && qtake.status == 0 && qtake_duyet"
              class="mr-2 mb-2"
              variant="success"
              @click.prevent="openApproveModal"
            >
              <i class="fas fa-check-square mr-2"></i>Confirm
            </b-button>
            <button
              v-if="!is_creating_qtake && qtake.status == 0 && qtake_duyet"
              class="btn btn-danger"
              style="float:right;"
              @click.prevent="openRejectModal"
            >
              <i class="fas fa-trash mr-2"></i> Reject
            </button>
            <!-- (is_creating_qtake && qtake_create) -->
            <button
              v-if="
                is_creating_qtake ||
                  (qtake_update && qtake.status == 0 && same_user) ||
                  (qtake.status == 0 && qtake_duyet) ||
                  qtake.status == 1
              "
              class="btn btn-info mr-2"
              style="float:right;"
              type="submit"
            >
              <i class="fas fa-save mr-2"></i> Save
            </button>
            <button
              v-if="qtake.status == 1 && qtake_duyet"
              class="btn btn-danger mr-2"
              style="float:right;"
              @click.prevent="unconfirmQtake"
            >
              <i class="fas fa-redo mr-2"></i> Unconfirmed
            </button>
          </b-col>
        </b-row>
        <b-row v-if="is_booking_account">
          <b-col>
            <b-form-group>
              <template v-slot:label>
                Requester's Email
                <span class="text-danger">*</span>
              </template>
              <b-form-input
                type="email"
                v-model="qtake.emailrequest"
                required
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group>
              <template v-slot:label>
                ATTN
                <span class="text-danger">*</span>
              </template>
              <b-form-input v-model="qtake.attn" required></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group>
              <template v-slot:label>
                Company
                <span class="text-danger">*</span>
              </template>
              <b-form-select
                v-model="qtake.qtakedepartmentid"
                :options="qtake_departments_list"
                value-field="id"
                text-field="name"
                required
              ></b-form-select>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row v-if="qtake.qtakedepartmentid != null">
          <b-col>
            <b-form-group>
              <template v-slot:label>
                Company's Full name
                <span class="text-danger">*</span>
              </template>
              <b-form-input v-model="qtake.company" required></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row v-if="qtake.qtakedepartmentid != null">
          <b-col>
            <b-form-group>
              <template v-slot:label>
                Address
                <span class="text-danger">*</span>
              </template>
              <b-form-input v-model="qtake.address" required></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group>
              <template v-slot:label>
                Project
                <span class="text-danger">*</span>
              </template>
              <b-form-input v-model="qtake.project" required></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group>
              <template v-slot:label>
                Location
                <span class="text-danger">*</span>
              </template>
              <b-form-select
                v-model="qtake.location"
                :options="locations"
                value-field="id"
                text-field="pickListValue"
                required
              ></b-form-select>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group>
              <template v-slot:label>
                Requirement
                <span class="text-danger">*</span>
              </template>
              <b-form-select
                v-model="qtake.requirement"
                :options="requirements"
                value-field="id"
                text-field="pickListValue"
                required
              ></b-form-select>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group>
              <template v-slot:label>
                Note
              </template>
              <b-form-input v-model="qtake.notes"></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row v-if="!is_creating_qtake">
          <b-col>
            <b-form-group>
              <template v-slot:label>
                Created at:
              </template>
              <b-form-input
                :value="createdat | moment('DD/MM/YYYY HH:mm:ss')"
                readonly
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row v-if="qtake.status == 1">
          <b-col>
            <!-- <button
              v-if="qtake.lockstatus == 0"
              class="btn btn-info mr-2"
              style="float:right;"
              @click.prevent="saveApproveInfo"
            >
              <i class="fas fa-save mr-2 mb-2"></i> Save
            </button> -->
            <button
              v-if="
                is_creating_qtake ||
                  (qtake_update && qtake.status == 0 && same_user) ||
                  (qtake.status == 0 && qtake_duyet) ||
                  qtake.status == 1
              "
              class="btn btn-info mr-2"
              style="float:right;"
              type="submit"
            >
              <i class="fas fa-save mr-2"></i> Save
            </button>
          </b-col>
        </b-row>
        <b-row v-if="is_approved">
          <b-col>
            <b-form-group>
              <template v-slot:label>
                System
              </template>
              <b-form-select
                v-model="qtake.system"
                :options="systems"
                value-field="id"
                text-field="pickListValue"
                :disabled="qtake.lockstatus == 1"
              ></b-form-select>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row v-if="is_approved">
          <b-col cols="4">
            <b-form-group>
              <template v-slot:label>
                Qtake Coordinator
              </template>
              <b-form-select
                v-model="qtake.coordinatorid"
                value-field="id"
                text-field="mahovaten"
                :disabled="true"
              ></b-form-select>
            </b-form-group>
            <!-- Commented 2024_03_12: Ms Nga request disable Coordinator.
            <b-form-group>
              <template v-slot:label>
                Qtake Coordinator
              </template>
              <b-form-select
                v-model="qtake.coordinatorid"
                :options="employees"
                value-field="id"
                text-field="mahovaten"
                :disabled="qtake.lockstatus == 1"
              ></b-form-select>
            </b-form-group> -->
          </b-col>
          <b-col cols="4">
            <b-form-group>
              <template v-slot:label>
                Qtake Operator
              </template>
              <b-form-select
                v-model="qtake.operatorid"
                :options="employees"
                value-field="id"
                text-field="mahovaten"
                :disabled="qtake.lockstatus == 1"
              ></b-form-select>
            </b-form-group>
          </b-col>
          <b-col cols="4">
            <b-form-group>
              <template v-slot:label>
                Qtake Assistant
              </template>
              <b-form-select
                v-model="qtake.assistantid"
                :options="employees"
                value-field="id"
                text-field="mahovaten"
                :disabled="qtake.lockstatus == 1"
              ></b-form-select>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group>
              <template v-slot:label>
                Shooting Dates
                <span class="text-danger">*</span>
                <button
                  v-if="
                    is_creating_qtake ||
                      (qtake_update && qtake.status == 0 && same_user) ||
                      (qtake.status == 0 && qtake_duyet)
                  "
                  class="btn btn-info"
                  style="float:right;"
                  @click.prevent="openDateModal"
                >
                  <i class="fas fa-plus mr-2"></i> Add date
                </button>
              </template>
              <b-table
                head-variant="dark"
                hover
                responsive
                striped
                small
                table-variant="light"
                :fields="shooting_date_fields"
                :items="shooting_date_items"
              >
                <template v-slot:cell(name)="data">{{
                  data.item.name
                }}</template>
                <template v-slot:cell(ngaybatdau)="data">{{
                  data.item.ngaybatdau | moment("DD/MM/YYYY")
                }}</template>
                <template v-slot:cell(ngayketthuc)="data">{{
                  data.item.ngayketthuc | moment("DD/MM/YYYY")
                }}</template>
                <template v-slot:cell(action)="data">
                  <span
                    v-if="
                      is_creating_qtake ||
                        (qtake_update && qtake.status == 0 && same_user) ||
                        (qtake.status == 0 && qtake_duyet)
                    "
                  >
                    <b-link
                      class="text-danger mr-2"
                      href="#"
                      @click.prevent="deleteDate(data)"
                    >
                      <i class="fas fa-trash"></i>
                    </b-link>
                  </span>
                </template>
              </b-table>
            </b-form-group>
          </b-col>
        </b-row>
      </b-form>
    </b-modal>
    <!-- END OF QTAKE BOOKING MODAL -->

    <!-- DATE MODAL -->
    <b-modal
      v-model="dateModalShow"
      @hidden="closeDateModal"
      header-bg-variant="info"
      header-text-variant="light"
      hide-footer
    >
      <template v-slot:modal-title>SHOOTING DATE</template>
      <b-form autocomplete="off">
        <b-row>
          <b-col cols="9">
            <b-form-input v-model="edit_name" require />
          </b-col>
          <b-col cols="3">
            <b-button
              class="mr-2 mb-2"
              style="float:right;width:100%;"
              @click.prevent="storeDate"
              variant="success"
            >
              <i class="fas fa-save mr-2"></i>Save
            </b-button>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="3">
            Start date:
          </b-col>
          <b-col cols="9">
            <my-date-picker v-model="edit_date_from"></my-date-picker>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="3">
            End date:
          </b-col>
          <b-col cols="9">
            <my-date-picker v-model="edit_date_to"></my-date-picker>
          </b-col>
        </b-row>
      </b-form>
    </b-modal>
    <!-- END OF DATE MODAL -->

    <!-- APPROVE MODAL -->
    <b-modal
      v-model="approveModalShow"
      @hidden="closeApproveModal"
      header-bg-variant="success"
      header-text-variant="light"
      hide-footer
    >
      <template v-slot:modal-title>
        APPROVE PROJECT
      </template>
      <b-form autocomplete="off" @submit.prevent="approveQtake">
        <b-row>
          <b-col>
            <b-form-group>
              <template v-slot:label>
                System
                <span class="text-danger">*</span>
              </template>
              <b-form-select
                v-model="approve_info.system"
                :options="systems"
                value-field="id"
                text-field="pickListValue"
                required
              ></b-form-select>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group>
              <template v-slot:label>
                Qtake Coordinator
              </template>
              <multiselect
                v-model="approve_info.coordinator"
                :options="employees"
                :disabled="true"
                placeholder
                track-by="id"
                label="mahovaten"
                selectedLabel="Selecting..."
                select-label="Enter to choose"
                deselectLabel="Enter to remove"
                :searchable="true"
              >
              </multiselect>
            </b-form-group>
            <!-- Commented 2024_03_12: Ms Nga request disable Coordinator.
            <b-form-group>
              <template v-slot:label>
                Qtake Coordinator
              </template>
              <multiselect
                v-model="approve_info.coordinator"
                placeholder
                :options="employees"
                track-by="id"
                label="mahovaten"
                selectedLabel="Selecting..."
                select-label="Enter to choose"
                deselectLabel="Enter to remove"
                :searchable="true"
              >
              </multiselect>
            </b-form-group> -->
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group>
              <template v-slot:label>
                Qtake operator
              </template>
              <multiselect
                v-model="approve_info.operator"
                placeholder
                :options="employees"
                track-by="id"
                label="mahovaten"
                selectedLabel="Selecting..."
                select-label="Enter to choose"
                deselectLabel="Enter to remove"
                :searchable="true"
              >
              </multiselect>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group>
              <template v-slot:label>
                Qtake assistant
              </template>
              <multiselect
                v-model="approve_info.assistant"
                placeholder
                :options="employees"
                track-by="id"
                label="mahovaten"
                selectedLabel="Selecting..."
                select-label="Enter to choose"
                deselectLabel="Enter to remove"
                :searchable="true"
              >
              </multiselect>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group>
              <b-button class="mr-2" variant="success" type="submit">
                <i class="fas fa-check-square mr-2"></i>Confirm
              </b-button>
              <b-button
                class="mr-2"
                variant="secondary"
                @click.prevent="closeApproveModal"
              >
                <i class="fas fa-times mr-2"></i>Cancel
              </b-button>
            </b-form-group>
          </b-col>
        </b-row>
      </b-form>
    </b-modal>
    <!-- END OF APPROVE MODAL -->

    <!-- REJECT MODAL -->
    <b-modal
      v-model="rejectModalShow"
      header-bg-variant="danger"
      header-text-variant="light"
      hide-footer
      title="Do you really delete this Qtake?"
    >
      <b-form autocomplete="false">
        <b-row>
          <b-col>
            <b-form-group>
              <template v-slot:label>
                Reason
                <span class="text-danger">*</span>
              </template>
              <b-form-input v-model="reject_comment"></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group>
              <b-button
                class="mr-2"
                variant="danger"
                @click.prevent="deleteQtake"
              >
                <i class="fas fa-trash mr-2"></i>Reject
              </b-button>
              <b-button
                class="mr-2"
                variant="secondary"
                @click.prevent="closeRejectModal"
              >
                <i class="fas fa-times mr-2"></i>Cancel
              </b-button>
            </b-form-group>
          </b-col>
        </b-row>
      </b-form>
    </b-modal>
    <!-- END OF REJECT MODAL -->
  </div>
</template>

<script>
import axios from "axios";
import QtakeSideBar from "../components/Qtake/QtakeSideBar";
import MyDatePicker from "../components/App/MyDatePickerUS";
import VueCal from "vue-cal";
import "vue-cal/dist/i18n/vi.js";
import "vue-cal/dist/vuecal.css";
import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.min.css";

export default {
  name: "Qtakes",
  components: {
    QtakeSideBar,
    VueCal,
    MyDatePicker,
    Multiselect,
  },
  data() {
    return {
      qtake: {
        id: 0,
        qtakedateid: 0,
        attn: null,
        qtakedepartmentid: null,
        project: null,
        location: null,
        requirement: null,
        company: "",
        address: "",
        notes: "",
        emailrequest: null,
        songay: 0,
        status: 0,
        lockstatus: 0,
        system: null,
        coordinatorid: 0,
        operatorid: 0,
        assistantid: 0,
        manhanvien: "",
      },
      shooting_date: {
        id: 0,
        qtakeid: 0,
        name: null,
        ngaybatdau: null,
        ngayketthuc: null,
      },
      approve_info: {
        qtakeid: 0,
        system: null,
        coordinator: null,
        operator: null,
        assistant: null,
      },
      qtake_flush: null,
      shooting_date_flush: null,
      approve_info_flush: null,
      shooting_date_fields: [
        {
          key: "name",
          label: "Name",
        },
        {
          key: "ngaybatdau",
          label: "Start date",
        },
        {
          key: "ngayketthuc",
          label: "End date",
        },
        {
          key: "action",
          label: "",
          thStyle: { width: "25px !important" },
        },
      ],
      shooting_date_items: [],
      qtakes: [],
      qtake_departments: [],
      qtake_departments_list: [],
      qtake_departments_selected: [],
      employees: [],
      last_qtake_departments_selected: null,
      fulld_qtake_departments_selected: null,
      startDate: null,
      endDate: null,
      activeView: "month",
      modalShow: false,
      dateModalShow: false,
      approveModalShow: false,
      qtake_indexes: [],
      locations: [
        // { id: null, type: "Please choose a location..." },
        // { id: 0, type: "STUDIO" },
        // { id: 1, type: "OUTSIDE" },
      ],
      requirements: [
        // { id: null, type: "Please choose requirement..." },
        // { id: 0, type: "Playback" },
        // { id: 1, type: "Playback & Live streaming" },
      ],
      systems: [
        // { id: null, type: "Please choose a system..." },
        // { id: 0, type: "STUDIO" },
        // { id: 1, type: "OVIDE" },
        // { id: 2, type: "4K STATION" },
      ],
      edit_date_from: "",
      edit_date_to: "",
      edit_name: null,
      is_creating_qtake: true,
      is_creating_date: true,
      reject_comment: "",
      rejectModalShow: false,
      createdat: "",
    };
  },
  computed: {
    qtake_read() {
      return this.$store.getters.hasPermission("qtake_read");
      //return true;
    },
    qtake_create() {
      return this.$store.getters.hasPermission("qtake_create");
      //return true;
    },
    qtake_update() {
      return this.$store.getters.hasPermission("qtake_update");
      //return true;
    },
    qtake_delete() {
      return this.$store.getters.hasPermission("qtake_delete");
      //return true;
    },
    qtake_duyet() {
      return this.$store.getters.hasPermission("qtake_duyet");
      //return true;
    },
    is_approved() {
      return this.qtake.status > 0;
    },
    same_user() {
      return this.$store.state.auth.name == this.qtake.manhanvien;
    },
    is_booking_account() {
      return this.$store.state.auth.name == this.$booking_account;
    },
  },
  beforeRouteEnter(to, from, next) {
    axios
      .all([
        axios.get("/api/qtakedepartment/use"),
        axios.get("/api/employee/getall"),
        axios.get(
          "/api/picklist?q=qtake_Location|qtake_Requirement|qtake_System"
        ),
      ])
      .then(
        axios.spread((qtake_department, employee, picklist) => {
          next((vm) =>
            vm.initData(qtake_department.data, employee.data, picklist.data)
          );
        })
      );
  },
  watch: {
    "qtake.qtakedepartmentid": function(newValue, oldValue) {
      if (!newValue) {
        this.qtake.address = "";
        this.qtake.company = "";
        return;
      }
      let department = this.qtake_departments.find((x) => x.id == newValue);
      this.qtake.company = department.fullname;
      this.qtake.address = department.address;
    },
  },
  methods: {
    initData(qtake_departments, employees, picklists) {
      this.employees = employees;
      this.qtake_departments = qtake_departments;
      this.qtake_departments_list = this.qtake_departments.slice();
      this.qtake_departments_selected = [];

      this.qtake_flush = this.$copy(this.qtake);
      this.shooting_date_flush = this.$copy(this.shooting_date);
      this.approve_info_flush = this.$copy(this.approve_info);

      this.systems = picklists.filter(
        (plt) => plt.pickListType == "qtake_System"
      );
      this.systems.unshift({
        id: null,
        pickListType: "qtake_System",
        pickListValue: "Please choose system...",
      });
      this.locations = picklists.filter(
        (plt) => plt.pickListType == "qtake_Location"
      );
      this.locations.unshift({
        id: null,
        pickListType: "qtake_Location",
        pickListValue: "Please choose a location...",
      });
      this.requirements = picklists.filter(
        (plt) => plt.pickListType == "qtake_Requirement"
      );
      this.requirements.unshift({
        id: null,
        pickListType: "qtake_Requirement",
        pickListValue: "Please choose a requirement...",
      });

      const select_all = { id: -1, name: "All" };
      this.qtake_departments.unshift(select_all);

      const select_null = { id: null, name: "Please select a Company..." };
      this.qtake_departments_list.unshift(select_null);

      for (let i = 0; i < qtake_departments.length; i++) {
        this.qtake_departments_selected.push(qtake_departments[i].id);
      }

      this.last_qtake_departments_selected = this.qtake_departments_selected;
      this.full_qtake_departments_selected = this.qtake_departments_selected;

      this.getQtakes();
    },
    getQtakes() {
      if (this.qtake_departments_selected != null) {
        let qtake_department_id = "";
        for (let i = 0; i < this.qtake_departments_selected.length; i++) {
          if (i != 0) qtake_department_id += ",";
          qtake_department_id += this.qtake_departments_selected[i];
        }

        axios
          .get("/api/qtake", {
            params: {
              qtake_department_id: qtake_department_id,
              start: this.startDate.getTime(),
              end: this.endDate.getTime(),
            },
          })
          .then((response) => {
            this.qtakes = response.data;
          })
          .catch((err) => {
            this.$toast.error(err.response.data, "Error", { timeout: 3000 });
          });
      }
    },
    viewChange(obj) {
      this.startDate = obj.startDate;
      this.endDate = obj.endDate;
      this.getQtakes();
    },
    openModal() {
      this.is_creating_qtake = true;
      this.modalShow = true;
    },
    openUpdateModal(event, e) {
      this.qtake = JSON.parse(JSON.stringify(event));

      let list_of_date = this.qtakes.filter((x) => x.id == event.id);
      for (let itr of list_of_date) {
        this.qtake_indexes.push(
          this.qtakes.findIndex((x) => x.qtakedateid == itr.qtakedateid)
        );
      }

      this.createdat = this.qtake.createdat;

      axios.get(`/api/qtake/dates_of_qtake/${this.qtake.id}`).then((res) => {
        this.shooting_date_items = res.data;
      });

      this.is_creating_qtake = false;
      this.modalShow = true;
    },
    closeModal() {
      this.qtake = this.$copy(this.qtake_flush);
      this.qtake_indexes = [];
      this.is_creating_qtake = false;
      this.shooting_date_items = [];
      this.modalShow = false;
    },
    change_qtake_department_selected() {
      // Find out if lost -1, deselect all
      if (
        this.qtake_departments_selected.length <
          this.last_qtake_departments_selected.length &&
        this.last_qtake_departments_selected.indexOf(-1) != -1 &&
        this.qtake_departments_selected.indexOf(-1) == -1
      ) {
        this.qtake_departments_selected = [];
      } // Find out if gain -1, select all
      else if (
        this.qtake_departments_selected.length >
          this.last_qtake_departments_selected.length &&
        this.qtake_departments_selected[
          this.qtake_departments_selected.length - 1
        ] == -1
      ) {
        this.qtake_departments_selected = this.full_qtake_departments_selected;
      }

      this.getQtakes();
      this.last_qtake_departments_selected = this.qtake_departments_selected;
    },
    openDateModal() {
      this.is_creating_date = true;
      this.edit_name = "Shooting date " + (this.shooting_date_items.length + 1);
      this.dateModalShow = true;
    },
    openUpdateDateModal() {
      this.dateModalShow = true;
    },
    closeDateModal() {
      this.shooting_date = this.$copy(this.shooting_date_flush);
      this.is_creating_date = false;
      this.edit_date_from = "";
      this.edit_date_to = "";
      this.dateModalShow = false;
    },
    submitQtake() {
      if (
        !this.qtake.attn ||
        !this.qtake.qtakedepartmentid ||
        !this.qtake.project ||
        this.qtake.location == null ||
        this.qtake.requirement == null
      ) {
        this.$toast.error("Please fill out all the information!", "Error", {
          timeout: 2000,
        });
        return;
      }

      if (this.shooting_date_items.length == 0) {
        this.$toast.error("There is no shooting date yet!", "Error", {
          timeout: 2000,
        });
        return;
      }

      if (
        this.is_booking_account &&
        !this.$email_format_regex.test(this.qtake.emailrequest)
      ) {
        this.$toast.error("Incorrect email format!", "Error", {
          timeout: 2000,
        });
        return;
      }

      if (!this.is_booking_account) {
        this.qtake.emailrequest = "";
      }

      if (this.qtake.system == null) this.qtake.system = 0;

      const payload = {
        shooting_dates: this.shooting_date_items,
        qtake: this.qtake,
      };

      if (this.is_creating_qtake) this.storeQtake(payload);
      else this.updateQtake(payload);
    },
    storeQtake(payload) {
      axios
        .post("/api/qtake", payload)
        .then((res) => {
          for (let data of res.data) {
            this.qtakes.push(data);
          }
          this.$toast.success("Successfully create Qtake!", "Success", {
            timeout: 2000,
          });
          this.closeModal();
        })
        .catch((err) => {
          this.$toast.error(err.response.data, "Lỗi", { timeout: 3000 });
        });
    },
    updateQtake(payload) {
      payload.shooting_date_items = []; // Because this update only the information not the dates
      axios
        .put("/api/qtake", payload)
        .then((res) => {
          for (let qtake of res.data) {
            let date_index = this.qtakes.findIndex(
              (x) => x.qtakedateid == qtake.qtakedateid
            );
            this.qtakes = this.$insert_array_parse_json(
              qtake,
              this.qtakes,
              date_index
            );
          }

          this.$toast.success("Successfully update Qtake!", "Success", {
            timeout: 2000,
          });
          this.closeModal();
        })
        .catch((err) => {
          this.$toast.error(err.response.data, "Lỗi", { timeout: 3000 });
        });
    },
    storeDate() {
      if (
        this.edit_date_from == "" ||
        this.edit_date_to == "" ||
        this.edit_name == ""
      ) {
        this.$toast.error("Please fill out all the information", "Error", {
          timeout: 2000,
        });
        return;
      }
      if (
        !this.$date_format_regex.test(this.edit_date_from) ||
        !this.$date_format_regex.test(this.edit_date_to)
      ) {
        this.$toast.error("Incorrect date format. Please try again!", "Error", {
          timeout: 2000,
        });
        return;
      }

      let added_date_from = this.$convert_string_date(this.edit_date_from);
      let added_date_to = this.$convert_string_date(this.edit_date_to);

      if (added_date_from > added_date_to) {
        this.$toast.error(
          "Start date can not be later than End Date",
          "Error",
          { timeout: 2000 }
        );
        return;
      }

      let shooting_date = Object.assign({}, this.shooting_date);

      if (this.is_creating_qtake) {
        //
        // If this is when creating a new qtake. We just  temporary add it to the array
        // and then create them all at once when we call POST on the Qtake API creation
        //

        for (let date of this.shooting_date_items) {
          if (
            added_date_from > date.ngayketthuc ||
            added_date_to < date.ngaybatdau
          ) {
            continue;
          } else {
            this.$toast.error(
              "Date already exist in [" +
                this.$convert_date_string(date.ngaybatdau) +
                " - " +
                this.$convert_date_string(date.ngayketthuc) +
                "]" +
                ". Please try again!",
              "Error",
              { timeout: 2000 }
            );
            return;
          }
        }

        shooting_date.id = this.qtake.songay;
        shooting_date.name = this.edit_name;
        shooting_date.ngaybatdau = added_date_from;
        shooting_date.ngayketthuc = added_date_to;
        shooting_date.qtakeid = this.qtake.id;

        this.shooting_date_items.push(shooting_date);
      } else {
        //
        // If this is when updateing a qtake. We just call PUT and update the day straight away
        //

        // We use API to validate date for us. We dont do it here
        shooting_date.name = this.edit_name;
        shooting_date.ngaybatdau = added_date_from;
        shooting_date.ngayketthuc = added_date_to;
        shooting_date.qtakeid = this.qtake.id;

        axios
          .post(`/api/qtake/date/${this.qtake.id}`, shooting_date)
          .then((res) => {
            this.shooting_date_items.push(res.data.date);
            this.qtakes.push(res.data.item);
          })
          .catch((err) => {
            this.$toast.error(err.response.data, "Lỗi", { timeout: 3000 });
          });
      }

      this.closeDateModal();
    },
    deleteDate(data) {
      if (this.is_creating_qtake) {
        //
        // Careless deleting when POST new Qtake.
        // We simply dont care
        //
        this.shooting_date_items.splice(data.index, 1);
        this.qtake.songay -= 1;
      } else {
        // When UPDATING we have to ask because we updating separately
        //(by calling separate DELELTE API) from the Qtake itself
        if (this.shooting_date_items.length == 1) {
          this.$toast.error(
            "Can not delete. There has to be atleast 1 date",
            "Lỗi",
            { timeout: 3000 }
          );
          return;
        }

        this.$toast.question(
          "Do you really want to delete this date?",
          "Warning",
          {
            timeout: 20000,
            close: false,
            overlay: true,
            displayMode: "once",
            position: "center",
            buttons: [
              [
                "<button><b>Có</b></button>",
                (instance, toast) => {
                  axios
                    .delete(`/api/qtake/date/${data.item.id}/${this.qtake.id}`)
                    .then((res) => {
                      this.shooting_date_items.splice(data.index, 1);
                      let deleted_item_index = this.qtakes.indexOf(
                        this.qtakes.find(
                          (x) => x.qtakedateid == res.data.deleted_id
                        )
                      );
                      this.qtakes.splice(deleted_item_index, 1);
                      let same_qtakes = this.qtakes.filter(
                        (x) => x.id == res.data.deleted_id
                      );
                      for (let qtake of same_qtakes) {
                        qtake.songay = res.data.songay;
                      }
                      this.$toast.success(
                        "Successfully delete date !",
                        "Success",
                        { timeout: 2000 }
                      );
                    })
                    .catch((err) => {
                      this.$toast.error(err.response.data, "Lỗi", {
                        timeout: 3000,
                      });
                    });
                  instance.hide({ transitionOut: "fadeOut" }, toast, "button");
                },
                true,
              ],
              [
                "<button>Không</button>",
                function(instance, toast) {
                  instance.hide({ transitionOut: "fadeOut" }, toast, "button");
                },
              ],
            ],
          }
        );
      }
    },
    deleteQtake() {
      if (!(this.reject_comment && this.reject_comment.length)) {
        this.$toast.error("Please enter reason", "Error", {
          timeout: 2000,
        });
      } else {
        const payload = {
          shooting_dates: this.shooting_date_items,
          qtake: this.qtake,
          comment: this.reject_comment,
        };
        axios
          .delete(`/api/qtake/${this.qtake.id}`)
          .then((res) => {
            for (let date_id of res.data) {
              var deleted_index = this.qtakes.indexOf(
                this.qtakes.find((x) => x.qtakedateid == date_id)
              );
              this.qtakes.splice(deleted_index, 1);
            }
            this.closeRejectModal();
            this.closeModal();
            this.$toast.success("Successfully delete Qtake !", "Success", {
              timeout: 2000,
            });

            axios
              .post("/api/sendemail/qtake_reject", payload)
              .then((res) => {
                this.reject_comment = "";
              })
              .catch((err) => this.$error_message(err.response.data));
          })
          .catch((err) => this.$error_message(err.response.data));
      }
    },
    findDepartment(id) {
      const temp = this.qtake_departments.find(function(el) {
        if (el.id == id) return el;
      });
      return temp == null ? "" : temp.name;
    },
    openApproveModal() {
      this.approveModalShow = true;
      this.approve_info.coordinator = null; // Commented 2024_03_12: Ms Nga request disable Coordinator.
      // this.approve_info.coordinator = this.employees.find((x) => x.id == 5); // ME002
    },
    closeApproveModal() {
      this.approve_info = this.$copy(this.approve_info_flush);
      this.approveModalShow = false;
    },
    approveQtake() {
      this.qtake.system = this.approve_info.system;
      this.qtake.coordinatorid =
        this.approve_info.coordinator == null
          ? 0 // Commented 2024_03_12: Ms Nga request disable Coordinator. Before Value: 5 ME002
          : this.approve_info.coordinator.id;
      this.qtake.operatorid =
        this.approve_info.operator == null
          ? null
          : this.approve_info.operator.id;
      this.qtake.assistantid =
        this.approve_info.assistant == null
          ? null
          : this.approve_info.assistant.id;

      let id = this.qtake.id;
      const payload = {
        shooting_dates: this.shooting_date_items,
        qtake: this.qtake,
      };

      axios
        .put("/api/qtake/confirm", payload)
        .then((res) => {
          for (let index of this.qtake_indexes) {
            this.qtakes[index].status = 1;
            this.qtakes[index].system = this.qtake.system;
            this.qtakes[index].coordinatorid = this.qtake.coordinatorid;
            this.qtakes[index].operatorid = this.qtake.operatorid;
            this.qtakes[index].assistantid = this.qtake.assistantid;
          }
          this.$success_message("Qtake confirm!", true);
          var minShootingDate = new Date(
            Math.min.apply(
              null,
              this.shooting_date_items.map((x) => new Date(x.ngaybatdau))
            )
          );
          this.closeModal();
          this.closeApproveModal();
          if (minShootingDate < Date.now())
            return this.$toast.warning(
              "Shooting date is started, can't send email!!!",
              "warning",
              {
                timeout: 3000,
              }
            );

          axios
            .post(`/api/sendemail/qtake_approval/${id}`)
            .catch((err) =>
              this.$toast.error(err.response.data, "Error", { timeout: 3000 })
            );
        })
        .catch((err) => {
          this.$error_message(err.response.data);
        });
    },
    // saveApproveInfo() {
    //   const payload = {
    //     shooting_dates: this.shooting_date_items,
    //     qtake: this.qtake,
    //   };
    //   axios
    //     .put("/api/qtake/confirm", payload)
    //     .then((res) => {
    //       for (let index of this.qtake_indexes) {
    //         this.qtakes[index].system = this.qtake.system;
    //         this.qtakes[index].coordinatorid = this.qtake.coordinatorid;
    //         this.qtakes[index].operatorid = this.qtake.operatorid;
    //         this.qtakes[index].assistantid = this.qtake.assistantid;
    //       }
    //       this.$success_message("Updated successfully!", true);
    //     })
    //     .catch((err) => {
    //       this.$error_message(err.response.data);
    //     });
    // },
    unconfirmQtake() {
      this.$toast.question(
        "Do you really want to uncorfirmed this Qtake?",
        "Warning",
        {
          timeout: 20000,
          close: false,
          overlay: true,
          displayMode: "once",
          position: "center",
          buttons: [
            [
              "<button><b>Có</b></button>",
              (instance, toast) => {
                this.qtake.system = 0;
                this.qtake.coordinatorid = 0; // Commented 2024_03_12: Ms Nga request disable Coordinator. Before Value: 5 ME002
                this.qtake.operatorid = null;
                this.qtake.assistantid = null;

                let id = this.qtake.id;

                const payload = {
                  shooting_dates: this.shooting_date_items,
                  qtake: this.qtake,
                };

                axios
                  .put("/api/qtake/unconfirm", payload)
                  .then((res) => {
                    for (let index of this.qtake_indexes) {
                      this.qtakes[index].status = 0;
                    }
                    this.$success_message("Qtake unconfirm!", true);
                    this.closeModal();
                  })
                  .catch((err) => {
                    this.$error_message(err.response.data);
                  });
                instance.hide({ transitionOut: "fadeOut" }, toast, "button");
              },
              true,
            ],
            [
              "<button>Không</button>",
              function(instance, toast) {
                instance.hide({ transitionOut: "fadeOut" }, toast, "button");
              },
            ],
          ],
        }
      );
    },
    openRejectModal() {
      this.rejectModalShow = true;
    },
    closeRejectModal() {
      this.rejectModalShow = false;
    },
    change_weekdays_headings_color(day_name) {
      if (day_name == "Sunday" || day_name == "Saturday") {
        return { "background-color": "#ffb284" };
      } else {
        return { "background-color": "#ffd18b" };
      }
    },
  },
};
</script>

<style>
#qtake_schedule_fluid .vuecal {
  height: calc(100vh - 120px);
}
#qtake_schedule_fluid.container-fluid {
  height: calc(100vh - 80px);
}
#modal_add_qtake_booking .modal-dialog-scrollable .modal-content {
  max-height: calc(100vh - 6rem);
}
</style>
